import React, { Fragment, useEffect, useMemo, useState } from "react";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { Edit, Video, Image, Activity, Clock, User, Folder } from "react-feather";
import { Button, Card, CardBody, Col, Container, Form, Label, Modal, ModalBody, ModalHeader, Row } from "reactstrap";
import { Typeahead } from "react-bootstrap-typeahead";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import axios from "axios";
import { API_ABSENCE, API_GRADE, API_HOMEWORK, API_USER } from "../../../redux/apiRoutes";
import { toast } from "react-toastify";
import DataTable from "react-data-table-component";
import Breadcrumb from "../../common/breadcrumb/breadcrumb";
import { useForm } from "react-hook-form";
import { v4 as uuidv4 } from 'uuid';
import DatePicker from 'react-datepicker';
import es from "date-fns/locale/es";

import Compressor from 'compressorjs';
import FilterComponent from "../../common/filter";
import SweetAlert from "sweetalert2";
import { uploadImage, uploadDocument, deleteFile, extractFilenameFromUrl } from "../../../utils/fileUpload";

import CKEditors from "react-ckeditor-component";

const HomeWork = () => {
  const user = useSelector((content) => content.User);
  const navigate = useNavigate();
  
  const [modal, setModal] = useState(false);
  const toggle = () => {setModal(!modal);  reset(); setEditinHomework(false); clearModal();};

  const clearModal = () => {
    setStudentSelected([]);
    setGradeSelected([]);
    setDate(new Date());
    setHomeworkAssignation('');
    setFileImage('')
    setContent('');
    setFilePDF('');
  }

  const [childSelected,setChildSelected] = useState([]);
  const [dataChilds,setdataChilds] = useState([]);
  const getChildsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&uuid=${user.uuid}`).then(response => {
      if(response.data.docs.length>0){
        if(response.data.docs[0].childs){
          const childs = []
          response.data.docs[0].childs.map(child=>{
            const addChild = {
              uuid: child.uuid,
              name: child.name,
              grade: child.grade,
            }
            childs.push(addChild);
          });
          setdataChilds(childs);
        }
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const [studentSelected,setStudentSelected] = useState([]);
  const [dataStudents,setdataStudents] = useState([]);
  const getStudentsList = async () => {
    await axios.get(`${API_USER}?status=ACTIVE&role=STUDENT`).then(response => {
      if(response.data.docs.length>0){
        const students = []
        response.data.docs.map(student=>{
          const addStudent = {
            uuid: student.uuid,
            name: student.names + ' ' + student.second_names,
            grade: student.grade,
          }
          students.push(addStudent);
        });
        setdataStudents(students);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Estudiantes: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const [gradeSelected,setGradeSelected] = useState([]);
  const [dataGrades,setdataGrades] = useState([]);
  const getGradesList = async () => {
    await axios.get(`${API_GRADE}?status=ACTIVE`).then(response => {
      if(response.data.docs.length>0){
        const grades = []
        response.data.docs.map(grade=>{
          const addGrade = {
            uuid: grade.uuid,
            name: grade.name + ' - ' + grade.level 
          }
          grades.push(addGrade);
        });
        setdataGrades(grades);
      }
    }).catch(e => {
      toast.error("No se pudo obtener el listado de Grados Escolares: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const [existHomeWork, setexistHomeWork] = useState(false);
  const [timeline, setTimeline] = useState([]);
  const [loadingTimeline, setLoadingTimeline] = useState(false);
  const getHomeworkByStudent = async (student) => {
    setChildSelected(student);
    setLoadingTimeline(true);
    if(student.length>0){
      setexistHomeWork(true);
      let gradeUuid = '';
      if (student[0].grade && Array.isArray(student[0].grade) && student[0].grade.length > 0) {
        gradeUuid = student[0].grade[0].uuid;
      } else if (student[0].grade && typeof student[0].grade === 'string') {
        gradeUuid = student[0].grade;
      } else if (student[0].grade && typeof student[0].grade === 'object') {
        gradeUuid = student[0].grade.uuid;
      }
      await axios.get(`${API_HOMEWORK}?status=ACTIVE&userUuids=${student[0].uuid}&gradeUuids=${gradeUuid}&limit=20`).then(response => {
        if(response.data.docs.length>0){
          setTimeline(response.data.docs);
        }else{
          setTimeline([]);
        }
        setLoadingTimeline(false);
      }).catch(e => {
        toast.error("No se pudo obtener el listado de Grados Escolares: " + e.message, {position: 'bottom-right', style:{color:'white'}});
        setLoadingTimeline(false);
      });
    }else{
      setexistHomeWork(false);
    }
  }

  const [dataHomeworkList, setDataHomeworkList] = useState([]);
  const [isGetHomeworkList, setIsGetHomeWorkList] = useState(false);
  const [editPermissions, setEditPermissions] = useState(false);
  const getHomeworkList = async () => {
    setIsGetHomeWorkList(true);

    let queryRule = '';
    if(user.role==='ADMIN' || user.role==='SISTEMAS' || user.role === "DIRECTOR"){
      setEditPermissions(true);
      queryRule = `status=ACTIVE`;
    }

    if(user.role === "SUBDIRECTOR"){
      setEditPermissions(true);
      queryRule = `status=ACTIVE&level=PREESCOLAR,MATERNAL`;
    }

    if(user.role === "DOCENT"){
      //getTechGrades(user.uuid);
      setEditPermissions(true);
      queryRule = `status=ACTIVE`;
    }
    
    await axios.get(`${API_HOMEWORK}?${queryRule}`).then(response => {
      if(response.data.docs.length>0){
        setDataHomeworkList(response.data.docs);
      }else{
        setDataHomeworkList([]);
      }
      setIsGetHomeWorkList(false);
    }).catch(e => {
      setIsGetHomeWorkList(false);
      toast.error("No se pudo obtener el listado de Tareas: " + e.message, {position: 'bottom-right', style:{color:'white'}});
    });
  }

  const estado = (status) =>{
    switch(status){
      case 'ACTIVE':
        return <div><span className="badge badge-success">Activa</span></div>;
      case 'DISABLED':
        return <div><span className="badge badge-warning">Desactivada</span></div>;
    }
  }

  const tipo = (type) =>{
    switch(type){
      case 'SELF':
        return <span className="text-primary">Individual</span>;
      case 'GROUP':
        return <span className="text-danger">Grupal</span>;
    }
  }

  const columns = [
    {
      name: "Titulo",
      selector: (row) => <b>{row.title}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Tipo",
      selector: (row) => <b>{tipo(row.type)}</b>,
      sortable: true,
      center: true,
      width: '100px'
    },
    {
      name: "Alumno(a)",
      selector: (row) => <b>{row.type === 'GROUP' ? 'N/A' : row.studentName}</b>,
      sortable: true,
      center: true,
      width: '150px'
    },
    {
      name: "Salón y Nivel",
      selector: (row) => row.grade + '-' +row.level,
      sortable: true,
      center: true,
      width: '180px'
    },
    {
      name: "Estado",
      selector: (row) => estado(row.status),
      sortable: true,
      center: true,
    },
    {
      name: "Fecha Entrega",
      selector: (row) => {
        if (!row.date) return '--';
        try {
          const date = new Date(row.date);
          if (isNaN(date.getTime())) return '--';
          return date.toLocaleDateString('es-MX', {
            timeZone: 'UTC',
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
          });
        } catch (error) {
          return '--';
        }
      },
      sortable: true,
      center: true,
    },
    {
      name: "Publicó",
      selector: (row) => row.creatorName,
      sortable: true,
      center: true,
    },
    {
      name: "Acciones",
      selector: (row) => <div style={{padding:5}}>
                          <Button color="light" style={{width: 40, padding: 6, marginRight:5, fontSize: 14}} onClick={()=>{handleEditAction(row, true)}}><i className="fa fa-pencil"></i></Button>
                          <Button color="light" style={{width: 40, padding: 6, marginRight:5, fontSize: 14}} onClick={()=>{handleDeleteAction(row)}}><i className="fa fa-trash"></i></Button>
                        </div>,
      width: '160px'
    },
  ];

  const [homeworkAssignation, setHomeworkAssignation] = useState('');
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    formState: { errors },
  } = useForm();

  const [fileImage, setFileImage] = useState('');
  const [filePDF, setFilePDF] = useState('');
  const [date, setDate] = useState(new Date());

  const handleChangeStart = (date) => {
    setDate(date);
  };

  const [savingHomework, setSaveHomework] = useState(false);
  const saveHomework = async (data) => {
    setSaveHomework(true);
    if (data !== "") {
      if(homeworkAssignation === ''){
        toast.error("Indica si la tarea es para un alumno(a) o grupo escolar", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(homeworkAssignation === 'SELF' && studentSelected.length<=0){
        toast.error("Indica el alumno(a) al que asignarás la tarea", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(homeworkAssignation === 'GROUP' && gradeSelected.length<=0){
        toast.error("Indica el grupo al que asignarás la tarea", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(date==="" || date === null){
        toast.error("Ingresa la fecha de entrega", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }
      data.date = date;
      data.description = content;

      data.uuid = uuidv4();
      data.creatorUuid = user.uuid;
      data.type = homeworkAssignation;
      if(homeworkAssignation === 'GROUP'){ 
        data.gradeUuids = [gradeSelected[0].uuid];
        data.level = gradeSelected[0].name.split(' - ')[1];
        data.grade = gradeSelected[0].name.split(' - ')[0];
      }
      if(homeworkAssignation === 'SELF'){ 
        data.userUuids = [studentSelected[0].uuid];
        data.level = studentSelected[0].grade[0].name.split(' - ')[1];
        data.grade = studentSelected[0].grade[0].name.split(' - ')[0];
      }
      data.status = 'ACTIVE';

      try {
        // Upload PDF if exists
        if(filePDF !== ''){
          const pdfUrl = await uploadDocument(filePDF);
          data.files = [pdfUrl];
        }

        // Upload image if exists
        if(fileImage !== ''){
          let file = fileImage;

          new Compressor(file, {
            quality: 0.8,
            success: async (compressedResult) => {   
              const compressed = compressedResult;
              
              const imageUrl = await uploadImage(compressed);
              data.pictures = [imageUrl];
              
              if(data.urls !== ''){data.urls = [data.urls] }
              if(data.videos !== ''){data.videos = [data.videos] }
        
              await axios.post(`${API_HOMEWORK}`,data).then(response => {
                if(response.data){
                  toggle();
                  getHomeworkList();
                  reset();
                  toast.success("¡Tarea creada con éxito!", {position: 'bottom-right', style:{color:'white'}});
                }
                setSaveHomework(false);
              }).catch(e => {
                setSaveHomework(false);
                toast.error("No se pudo crear la tarea: " + e.message, {position: 'bottom-right', style:{color:'white'}});
              });
            },
            error: (err) => {
              toast.error("Error al comprimir la imagen: "+err, {position: 'bottom-right', style:{color:'white'}});
              setSaveHomework(false);
            }
          });
        } else {
          if(data.urls !== ''){data.urls = [data.urls] }
          if(data.videos !== ''){data.videos = [data.videos] }
    
          await axios.post(`${API_HOMEWORK}`,data).then(response => {
            if(response.data){
              toggle();
              getHomeworkList();
              reset();
              toast.success("¡Tarea creada con éxito!", {position: 'bottom-right', style:{color:'white'}});
            }
            setSaveHomework(false);
          }).catch(e => {
            setSaveHomework(false);
            toast.error("No se pudo crear la tarea: " + e.message, {position: 'bottom-right', style:{color:'white'}});
          });
        }
      } catch (error) {
        setSaveHomework(false);
        toast.error("Error al subir archivos: " + error.message, {position: 'bottom-right', style:{color:'white'}});
      }
    } else {
      errors.showMessages();
    }
  };

  const [currentHomeWork, setCurrentHomework] = useState({});
  const handleEditAction = (homework, refresh) => {
    if(refresh){toggle()}
    setEditinHomework(true);
    setCurrentHomework(homework);
    
    if(homework.userUuids!==undefined && homework.userUuids !== null){
      dataStudents.map((student)=>{
        if(student.uuid===homework.userUuids[0]){
          setStudentSelected([student]);
        }
      });
    }

    if(homework.gradeUuids!==undefined && homework.gradeUuids !== null){
      dataGrades.map((grade)=>{
        if(grade.uuid===homework.gradeUuids[0]){
          setGradeSelected([grade]);
        }
      });
    }

    setHomeworkAssignation(homework.type);
    
    setTimeout(()=>{
      setDate(new Date(homework.date));
      setValue('title', homework.title);
      setContent(homework.description)
      if(homework.urls!==''){
        setValue('urls', homework.urls[0]);
      }else{
        setValue('urls', homework.urls);
      }
      if(homework.videos!==''){
        setValue('videos', homework.videos[0]);
      }else{
        setValue('videos', homework.videos);
      }
    },500)
  }

  const [removingPicture, setRemovingPicture] = useState(false);

  const handleRemovePicture = async () => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la imagen de la tarea`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        setRemovingPicture(true);

        try {
          // Delete the image file
          if (currentHomeWork.pictures && currentHomeWork.pictures.length > 0) {
            const filename = extractFilenameFromUrl(currentHomeWork.pictures[0]);
            if (filename) {
              await deleteFile(filename);
            }
          }

          await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,{pictures:[]}).then(response => {
            handleEditAction(response.data, false);
            getHomeworkList();
            setRemovingPicture(false);
            SweetAlert.fire("¡Listo!", `imagen eliminada`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la imagen: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting image file:', error);
          // Continue with deletion even if file deletion fails
          await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,{pictures:[]}).then(response => {
            handleEditAction(response.data, false);
            getHomeworkList();
            setRemovingPicture(false);
            SweetAlert.fire("¡Listo!", `imagen eliminada`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la imagen: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const [removingPdf, setRemovingPdf] = useState(false);

  const handleRemovePdf = async () => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará el PDF Adjunto de la tarea`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        setRemovingPdf(true);

        try {
          // Delete the PDF file
          if (currentHomeWork.files && currentHomeWork.files.length > 0) {
            const filename = extractFilenameFromUrl(currentHomeWork.files[0]);
            if (filename) {
              await deleteFile(filename);
            }
          }

          await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,{files:[]}).then(response => {
            handleEditAction(response.data, false);
            getHomeworkList();
            setRemovingPdf(false);
            SweetAlert.fire("¡Listo!", `PDF eliminado`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la PDF: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting PDF file:', error);
          // Continue with deletion even if file deletion fails
          await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,{files:[]}).then(response => {
            handleEditAction(response.data, false);
            getHomeworkList();
            setRemovingPdf(false);
            SweetAlert.fire("¡Listo!", `PDF eliminado`, "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la PDF: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const [isEditingHomework, setEditinHomework] = useState(false);
  const [patchingHomework, setPatchingHomework] = useState(false);
  const patchHomework = async (data) => {
    setPatchingHomework(true);

    if (data !== "") {
      data.description = content;

      if(homeworkAssignation === ''){
        toast.error("Indica si la tarea es para un alumno(a) o grupo escolar", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(homeworkAssignation === 'SELF' && studentSelected.length<=0){
        toast.error("Indica el alumno(a) al que asignarás la tarea", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(homeworkAssignation === 'GROUP' && gradeSelected.length<=0){
        toast.error("Indica el grupo al que asignarás la tarea", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      if(date==="" || date === null){
        toast.error("Ingresa la fecha de entrega", {position: 'bottom-right', style:{color:'white'}});
        setSaveHomework(false);
        return;
      }

      data.date = date;
      data.type = homeworkAssignation;
      if(homeworkAssignation === 'GROUP'){ 
        data.gradeUuids = [gradeSelected[0].uuid];
        data.level = gradeSelected[0].name.split(' - ')[1];
        data.grade = gradeSelected[0].name.split(' - ')[0];
      }
      if(homeworkAssignation === 'SELF'){ 
        data.userUuids = [studentSelected[0].uuid];
        data.level = studentSelected[0].grade[0].name.split(' - ')[1];
        data.grade = studentSelected[0].grade[0].name.split(' - ')[0];
      }

      try {
        // Upload PDF if exists
        if(filePDF !== ''){
          const pdfUrl = await uploadDocument(filePDF);
          data.files = [pdfUrl];
        }

        // Upload image if exists
        if(fileImage !== ''){
          let file = fileImage;

          new Compressor(file, {
            quality: 0.8,
            success: async (compressedResult) => {   
              const compressed = compressedResult;
              
              const imageUrl = await uploadImage(compressed);
              data.pictures = [imageUrl];
              
              if(data.urls !== ''){data.urls = [data.urls] }
              if(data.videos !== ''){data.videos = [data.videos] }
        
              await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,data).then(response => {
                if(response.data){
                  getHomeworkList();
                  toggle();
                  setPatchingHomework(false);
                  toast.success("¡Tarea actualizada con éxito!", {position: 'bottom-right', style:{color:'white'}});
                }
                setPatchingHomework(false);
              }).catch(e => {
                setPatchingHomework(false);
                toast.error("No se pudo actualizar la tarea: " + e.message, {position: 'bottom-right', style:{color:'white'}});
              });
            },
            error: (err) => {
              toast.error("Error al comprimir la imagen: "+err, {position: 'bottom-right', style:{color:'white'}});
              setPatchingHomework(false);
            }
          });
        } else {
          if(data.urls !== ''){data.urls = [data.urls] }
          if(data.videos !== ''){data.videos = [data.videos] }
    
          await axios.patch(`${API_HOMEWORK}/${currentHomeWork.uuid}`,data).then(response => {
            if(response.data){
              getHomeworkList();
              toggle();
              setPatchingHomework(false);
              toast.success("¡Tarea actualizada con éxito!", {position: 'bottom-right', style:{color:'white'}});
            }
            setPatchingHomework(false);
          }).catch(e => {
            setPatchingHomework(false);
            toast.error("No se pudo actualizar la tarea: " + e.message, {position: 'bottom-right', style:{color:'white'}});
          });
        }
      } catch (error) {
        setPatchingHomework(false);
        toast.error("Error al subir archivos: " + error.message, {position: 'bottom-right', style:{color:'white'}});
      }
    } else {
      errors.showMessages();
    }
  }

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(
    false
  );

  const handleDeleteAction = (data) => {
    SweetAlert.fire({
      title: "¿Continuamos?",
      text: `Se eliminará la tarea: ${data.title} (para todos los involucrados)`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Si",
      cancelButtonText: "Cancelar",
      reverseButtons: true,
    }).then(async (result) => {
      if (result.value) {
        try {
          // Delete associated files
          if (data.pictures && data.pictures.length > 0) {
            for (const pictureUrl of data.pictures) {
              const filename = extractFilenameFromUrl(pictureUrl);
              if (filename) {
                await deleteFile(filename);
              }
            }
          }
          
          if (data.files && data.files.length > 0) {
            for (const fileUrl of data.files) {
              const filename = extractFilenameFromUrl(fileUrl);
              if (filename) {
                await deleteFile(filename);
              }
            }
          }

          await axios.delete(`${API_HOMEWORK}/${data.uuid}`).then(response => {
            getHomeworkList();
            SweetAlert.fire("¡Listo!", "tarea eliminada", "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la tarea: " + error
              );
            }, 200);
          });
        } catch (error) {
          console.error('Error deleting files:', error);
          // Continue with deletion even if file deletion fails
          await axios.delete(`${API_HOMEWORK}/${data.uuid}`).then(response => {
            getHomeworkList();
            SweetAlert.fire("¡Listo!", "tarea eliminada", "success");
          }).catch(error => {
            setTimeout(() => {
              toast.error(
                "Error al eliminar la tarea: " + error
              );
            }, 200);
          });
        }
      }
    });
  }

  const filteredItems = dataHomeworkList.filter(
    item =>
      JSON.stringify(item)
        .toLowerCase()
        .indexOf(filterText.toLowerCase()) !== -1
  );

  const subHeaderComponent = useMemo(() => {
    const handleClear = () => {
      if (filterText) {
        setResetPaginationToggle(!resetPaginationToggle);
        setFilterText("");
      }
    };

    return (
      <FilterComponent
        onFilter={e => setFilterText(e.target.value)}
        onClear={handleClear}
        filterText={filterText}
      />
    );
  }, [filterText, resetPaginationToggle]);

  const [content, setContent] = useState("");
  const onChange = (evt) => {
    const newContent = evt.editor.getData();
    setContent(newContent);
  };

  useEffect(() => {
    if(
      user.role !== 'ADMIN' 
      && user.role !== "SISTEMAS"
      && user.role !== "TUTOR"
      && user.role !== "DIRECTOR"
      && user.role !== "SUBDIRECTOR"
      && user.role !== "DOCENT"
    ){
      navigate('/inicio');
    }
    if(user.role!=='TUTOR'){
      getStudentsList();
      getGradesList();
      getHomeworkList();
    }else{
      getChildsList();
    }
  }, [navigate]);

  return (
    <Fragment>
      <Breadcrumb parent="Herramientas" title="Tareas"/>
      {user !== null && user !== undefined && user.role === 'TUTOR' ?
        <>
          <Container style={{background:'white', margin:20, borderRadius: 10}}>
            <Row className="g-3 dflex mb-3 p-3 pb-4">
              <Col md="12">
                <Typeahead
                  id="childFinder"
                  clearButton
                  defaultSelected={childSelected}
                  labelKey="name"
                  options={dataChilds}
                  placeholder="Buscar Alumno(a)..."
                  onChange={(e)=>{getHomeworkByStudent(e)}}
                />
              </Col>
            </Row>
          </Container>
          <Container fluid={true}>
            { existHomeWork ?
            <>
            <div className="mb-5"></div>
              { 
                !loadingTimeline ?
                  timeline.length > 0 ?
                  <VerticalTimeline>
                    {timeline.map(time=>{
                      let icon = <Edit />;
                      if(time.pictures && time.pictures.length>0){
                        icon = <Image />
                      }
                      if(time.videos && time.videos.length>0){
                        icon = <Video />
                      }
                      const date = (() => {
                        try {
                          const parsedDate = new Date(time.createdAt);
                          if (isNaN(parsedDate.getTime())) {
                            return new Date();
                          }
                          return parsedDate;
                        } catch (error) {
                          return new Date();
                        }
                      })();
                      return(
                        <>
                          <VerticalTimelineElement
                            key={time.uuid}
                            className="vertical-timeline-element--work"
                            animate={true}
                            date={date.toLocaleString('es-MX', {
                              timeZone: 'UTC',
                              year: 'numeric',
                              month: 'long',
                              day: 'numeric',
                              hour: '2-digit',
                              minute: '2-digit'
                            })}
                            icon={icon}
                          >
                            <h4 className="vertical-timeline-element-subtitle mb-2">
                            {time.title}
                            </h4>
                            <h7>
                              <b><Clock size={15} /> Entregar:</b> {(() => {
                                if (!time.date) return '--';
                                try {
                                  const date = new Date(time.date);
                                  if (isNaN(date.getTime())) return '--';
                                  return date.toLocaleDateString('es-MX', {
                                    timeZone: 'UTC',
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric'
                                  });
                                } catch (error) {
                                  return '--';
                                }
                              })()}
                              <br/>
                              <b><Folder size={15} /> Tipo: {tipo(time.type)}</b>
                              <br/>
                              <b><User size={15} /> Publicado por: {time.creatorName}</b>
                            </h7>
                            <div style={{marginTop:20}} dangerouslySetInnerHTML={{__html:time.description}}></div>
                            {time.urls && time.urls.length>0 ?
                              <p>Enlaces: <a href={time.urls[0]} target="_blank">{time.urls[0]}</a></p>
                            : null}

                            {time.files && time.files.length>0 ?
                            <a href={time.files[0]} target="_blank">
                            Adjunto PDF</a>: null}
                            {time.pictures && time.pictures.length>0 ?
                            <a href={time.pictures[0]} target="_blank">
                            <img
                              className="img-fluid p-t-20 w-100"
                              src={time.pictures[0]}
                              alt="timelineImg"
                            /></a>: null}
                            {time.videos && time.videos.length>0 ?
                            <div className="embed-responsive embed-responsive-21by9 ratio ratio-21x9 m-t-20">
                              {/* <iframe
                                src={time.videos[0]}
                                allowFullScreen
                                title="videotimeline"
                              ></iframe> */}
                              <a href={time.videos[0]} target="_blank">{time.videos[0]}</a>
                            </div>: null}
                          </VerticalTimelineElement>
                        </>
                      )
                    })}
                  </VerticalTimeline>
                  : <h3 className="text-secondary" style={{textAlign:'center'}}>Sin tareas asignadas</h3>
                : <h3 className="text-secondary" style={{textAlign:'center'}}>Cargando...</h3> }
            </>
            : null}
          </Container>
        </>
      : null}

      {user !== null && user !== undefined && user.role !== 'TUTOR' ?
        <>
          <Container fluid={true}>
            <Row>
              <Col sm="12" style={{display:'flex', justifyContent:'flex-end', marginBottom: 20, paddingRight:30}}>
                <Button color="primary" onClick={toggle}>Crear Tarea</Button>
              </Col>
            </Row>

            <Row>
              <Col sm="12">
                <Card>
                  <CardBody className="data-tables">
                    <DataTable
                      columns={columns}
                      striped={true}
                      center={true}
                      data={filteredItems}
                      subHeader
                      pagination
                      subHeaderComponent={subHeaderComponent}
                      noDataComponent={<b style={{padding:10}}>No hay tareas creadas</b>}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>

          <Modal isOpen={modal} toggle={toggle}>
            <ModalHeader toggle={toggle}>{isEditingHomework ? 'Editar Tarea' : 'Crear Nueva Tarea' }
              <button className="btn-close invisible" type="button">
                <span aria-hidden="true" className="visible" onClick={toggle}></span>
              </button>
            </ModalHeader>
            <ModalBody>
              <div className="container">
                <Row className="g-3 dflex">
                  <Col md="12">
                    <select className="form-control mb-1" defaultValue={homeworkAssignation} onChange={(e)=>setHomeworkAssignation(e.target.value)}>
                      <option value="">-- Elige el tipo de tarea --</option>
                      <option value="SELF">Para un alumno(a) en especifico</option>
                      <option value="GROUP">Para un grupo en general</option>
                    </select>
                  </Col>
                </Row>
                <Form className="needs-validation" noValidate="" onSubmit={handleSubmit( isEditingHomework ? patchHomework : saveHomework)} style={{padding:20}}>
                  {homeworkAssignation === 'SELF' ?
                  <Row className="g-3 dflex mb-3">
                    <Col md="12">
                      <Label className="form-label font-weight-bold">
                        Alumno(a)
                      </Label>
                      <Typeahead
                        id="gradeFinder"
                        clearButton
                        defaultSelected={studentSelected}
                        labelKey="name"
                        options={dataStudents}
                        placeholder="Buscar Alumno(a)..."
                        onChange={(e)=>{setStudentSelected(e)}}
                      />
                    </Col>
                  </Row> : null}
                  {homeworkAssignation === 'GROUP' ?
                  <Row className="g-3 dflex mb-3">
                    <Col md="12">
                      <Label className="form-label font-weight-bold">
                        Grado
                      </Label>
                      <Typeahead
                        id="gradeFinder"
                        clearButton
                        defaultSelected={gradeSelected}
                        labelKey="name"
                        options={dataGrades}
                        placeholder="Buscar Grupo de Alumnos..."
                        onChange={(e)=>{setGradeSelected(e)}}
                      />
                    </Col>
                  </Row> : null }
                  <Row className="g-3 dflex mb-3">
                    <Col md="12">
                      <Label className="form-label font-weight-bold" for="validTitle">
                        Fecha Entrega
                      </Label>
                      <DatePicker className="form-control digits"
                          selected={date}
                          onChange={handleChangeStart}
                          selectsStart
                          minDate={new Date()}
                          locale={es}
                          dateFormat={'dd/MM/yyyy'}
                        />
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-3">
                    <Col md="12">
                      <Label className="form-label font-weight-bold" for="validTitle">
                        Titulo
                      </Label>
                      <input className="form-control" id="validTitle" type="text" placeholder="Titulo" name="title" {...register("title", { required: true })} />
                      <span>{errors.title && "Titulo requerido"}</span>
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-3">
                    <Col md="12">
                      <Label className="form-label font-weight-bold" for="validDetails">
                        Detalles
                      </Label>
                      <CKEditors
                        activeclassName="p10"
                        content={content}
                        events={{
                          change: onChange,
                        }}
                      />
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-4">
                    <Col md="12">
                      <Label className="form-label font-weight-bold">
                        Imagen
                      </Label>&nbsp;
                      {isEditingHomework ?
                        <>
                          {currentHomeWork.pictures !== null && currentHomeWork.pictures !== undefined && currentHomeWork.pictures.length > 0 ?
                          <div>
                            <img src={`${currentHomeWork.pictures[0]}`} style={{maxWidth:300}} />
                            <p>{!removingPicture ? <span onClick={handleRemovePicture} style={{color:'red', cursor:'pointer'}}>Quitar</span> : null}</p>
                          </div>
                          : 
                          <input type="file" className="form-control" accept="image/*" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                            toast.error("El archivo no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                            e.target.files = null;
                            e.target.value = null;
                            return;
                          }setFileImage(e.target.files[0])}}/>
                          }
                        </>
                      :
                      <input type="file" className="form-control" accept="image/*" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                        toast.error("El archivo no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                        e.target.files = null;
                        e.target.value = null;
                        return;
                      }setFileImage(e.target.files[0])}}/>}
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-4">
                    <Col md="12">
                      <Label className="form-label font-weight-bold">
                        PDF
                      </Label>&nbsp;
                      {isEditingHomework ?
                        <>
                          {currentHomeWork.files !== null && currentHomeWork.files !== undefined && currentHomeWork.files.length > 0 ?
                          <div>
                            <a href={currentHomeWork.files[0]} target="_blank">{currentHomeWork.files[0]}</a>
                            <p>{!removingPicture ? <span onClick={handleRemovePdf} style={{color:'red', cursor:'pointer'}}>Quitar</span> : null}</p>
                          </div>
                          : 
                          <input type="file" className="form-control" accept="application/pdf" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                            toast.error("El PDF no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                            e.target.files = null;
                            e.target.value = null;
                            return;
                          }setFilePDF(e.target.files[0])}}/>
                          }
                        </>
                      :
                      <input type="file" className="form-control" accept="application/pdf" onChange={(e)=>{if (e.target.files[0].size > 2000000) {
                        toast.error("El PDF no puede pesar más de 2MB",{position: 'bottom-right', style:{color:'white'}});
                        e.target.files = null;
                        e.target.value = null;
                        return;
                      }setFilePDF(e.target.files[0])}}/>}
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-4">
                    <Col md="12">
                      <Label className="form-label font-weight-bold" for="validUrl">
                        Enlace Web
                      </Label>
                      <input className="form-control" id="validUrl" type="text" placeholder="Enlace Web https://" name="urls" {...register("urls")} />
                    </Col>
                  </Row>
                  <Row className="g-3 dflex mb-4">
                    <Col md="12">
                      <Label className="form-label font-weight-bold" for="validYoutube">
                        Video Youtube
                      </Label>
                      <input className="form-control" id="validYoutube" type="text" placeholder="Video Youtube Embeded https://" name="videos" {...register("videos")} />
                    </Col>
                  </Row>
                  <Row style={{display:'flex', justifyContent:'end', paddingTop:20}}>
                  {
                    isEditingHomework ? 
                      <Button disabled={patchingHomework} className="btn btn-primary" style={{width:150}} color="primary">{"Guardar"}</Button> 
                    : 
                      <Button disabled={savingHomework} className="btn btn-primary" style={{width:150}} color="primary">{"Guardar"}</Button> 
                  }
                  </Row>
                </Form>
              </div>
            </ModalBody>
          </Modal>

        </>
      : null }
    </Fragment>
  );
};

export default HomeWork;
